/*
 * @Author: Dom
 * @Date: 2022-06-13 18:03:42
 * @LastEditTime: 2022-06-14 00:15:05
 * @LastEditors: Dom
 * @FilePath: \operator-web\src\store\shipment.ts
 */
import { Mutation, Action } from 'vuex'
import { StoreModuleType } from '@/utils/store'
import {ResponseData} from '@/utils/request'
import { ShipmentOrderType, ShipmentOrderResType } from '@/services/data.d'
import {getWaitShipmentOrder} from '@/services/shipment'

export interface StateType {
    errorMsg?: string;
    infoData: ShipmentOrderResType
}

export interface ModuleType extends StoreModuleType<StateType> {
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        getinfo: Mutation<StateType>;
    },
    actions: {
        getWaitShipmentOrderFn: Action<StateType,StateType>;
    }
}

const initState: StateType = {
    errorMsg: undefined,
    infoData: {
        expectNumber: 0,
        expectWeight: 0,
        createPickup: false
    }
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'shipment',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload
        },
        getinfo(state, payload){
            state.infoData = payload
        },
    },
    actions: {
        //获取待交运的物流单信息
        async getWaitShipmentOrderFn({ commit }, params:ShipmentOrderType){
            let msg: string | undefined = undefined
            try{
                const response:ResponseData = await getWaitShipmentOrder(params)
                const {body} = response
                commit('getinfo',body)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
    }
}

export default StoreModel
